/**
 * `NetworkMonitor` over `navigator.onLine` and the window's online/offline
 * events.
 *
 * `navigator.onLine` is famously optimistic — it reports the interface being
 * up, not the internet being reachable — but that is the signal the browser
 * offers, and the engine treats it as a hint rather than a guarantee: a drain
 * that goes out on a lying `true` fails and reschedules with backoff.
 */
import type { NetworkMonitor } from '@kapture/platform';

export const webNetwork: NetworkMonitor = {
  isOnline(): boolean {
    return typeof navigator === 'undefined' ? true : navigator.onLine;
  },
  subscribe(onChange: (online: boolean) => void): () => void {
    const goOnline = () => onChange(true);
    const goOffline = () => onChange(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  },
};
